import { IAppState } from 'shared/common/state';

export const randomBooleanReducer = (state: IAppState): IAppState => {
  return {
    ...state,
    randomBoolean: state.randomBoolean,
  };
};
